import { useState, useEffect } from 'react';

export default function CookieBanner() {
  const [showBanner, setShowBanner] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [preferences, setPreferences] = useState({
    essential: true,
    analytics: false,
    marketing: false,
  });

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const acceptAll = () => {
    const allAccepted = {
      essential: true,
      analytics: true,
      marketing: true,
      timestamp: new Date().toISOString(),
    };
    localStorage.setItem('cookieConsent', JSON.stringify(allAccepted));
    setShowBanner(false);
  };

  const rejectAll = () => {
    const essentialOnly = {
      essential: true,
      analytics: false,
      marketing: false,
      timestamp: new Date().toISOString(),
    };
    localStorage.setItem('cookieConsent', JSON.stringify(essentialOnly));
    setShowBanner(false);
  };

  const savePreferences = () => {
    const savedPreferences = {
      ...preferences,
      timestamp: new Date().toISOString(),
    };
    localStorage.setItem('cookieConsent', JSON.stringify(savedPreferences));
    setShowBanner(false);
    setShowSettings(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-4 left-4 z-50 pointer-events-none">
      <div className="pointer-events-auto w-full max-w-sm bg-white rounded-lg shadow-lg border border-gray-200">
        {!showSettings ? (
          <div className="p-4">
            <div className="flex items-start gap-3 mb-3">
              <div className="w-8 h-8 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-cookie-line text-lg text-teal-600"></i>
              </div>
              <div className="flex-1">
                <p className="text-gray-700 text-xs leading-relaxed">
                  Nous utilisons des cookies pour améliorer votre expérience.
                </p>
              </div>
            </div>

            <div className="flex flex-wrap gap-2">
              <button
                onClick={acceptAll}
                className="px-4 py-2 bg-teal-600 text-white rounded-lg text-xs font-semibold hover:bg-teal-700 transition-all whitespace-nowrap cursor-pointer"
              >
                Accepter
              </button>
              <button
                onClick={rejectAll}
                className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg text-xs font-semibold hover:bg-gray-300 transition-all whitespace-nowrap cursor-pointer"
              >
                Refuser
              </button>
              <button
                onClick={() => setShowSettings(true)}
                className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg text-xs font-semibold hover:bg-gray-50 transition-all whitespace-nowrap cursor-pointer"
              >
                Options
              </button>
            </div>
          </div>
        ) : (
          <div className="p-4">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-sm font-bold text-gray-900">
                Préférences
              </h3>
              <button
                onClick={() => setShowSettings(false)}
                className="w-6 h-6 flex items-center justify-center text-gray-400 hover:text-gray-600 cursor-pointer"
              >
                <i className="ri-close-line text-lg"></i>
              </button>
            </div>

            <div className="space-y-3 mb-4">
              {/* Essential Cookies */}
              <div className="flex items-center justify-between">
                <div className="flex-1">
                  <h4 className="text-xs font-semibold text-gray-900">
                    Essentiels
                  </h4>
                </div>
                <div className="ml-3">
                  <div className="w-10 h-5 bg-teal-600 rounded-full flex items-center px-0.5">
                    <div className="w-4 h-4 bg-white rounded-full ml-auto"></div>
                  </div>
                </div>
              </div>

              {/* Analytics Cookies */}
              <div className="flex items-center justify-between">
                <div className="flex-1">
                  <h4 className="text-xs font-semibold text-gray-900">
                    Analytiques
                  </h4>
                </div>
                <div className="ml-3">
                  <button
                    onClick={() =>
                      setPreferences({ ...preferences, analytics: !preferences.analytics })
                    }
                    className={`w-10 h-5 rounded-full flex items-center px-0.5 transition-colors cursor-pointer ${
                      preferences.analytics ? 'bg-teal-600' : 'bg-gray-300'
                    }`}
                  >
                    <div
                      className={`w-4 h-4 bg-white rounded-full transition-transform ${
                        preferences.analytics ? 'ml-auto' : ''
                      }`}
                    ></div>
                  </button>
                </div>
              </div>

              {/* Marketing Cookies */}
              <div className="flex items-center justify-between">
                <div className="flex-1">
                  <h4 className="text-xs font-semibold text-gray-900">
                    Marketing
                  </h4>
                </div>
                <div className="ml-3">
                  <button
                    onClick={() =>
                      setPreferences({ ...preferences, marketing: !preferences.marketing })
                    }
                    className={`w-10 h-5 rounded-full flex items-center px-0.5 transition-colors cursor-pointer ${
                      preferences.marketing ? 'bg-teal-600' : 'bg-gray-300'
                    }`}
                  >
                    <div
                      className={`w-4 h-4 bg-white rounded-full transition-transform ${
                        preferences.marketing ? 'ml-auto' : ''
                      }`}
                    ></div>
                  </button>
                </div>
              </div>
            </div>

            <div className="flex gap-2">
              <button
                onClick={savePreferences}
                className="flex-1 px-4 py-2 bg-teal-600 text-white rounded-lg text-xs font-semibold hover:bg-teal-700 transition-all whitespace-nowrap cursor-pointer"
              >
                Enregistrer
              </button>
              <button
                onClick={() => setShowSettings(false)}
                className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg text-xs font-semibold hover:bg-gray-50 transition-all whitespace-nowrap cursor-pointer"
              >
                Annuler
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
